import React from 'react';
import TemplateProyect from '../TemplateProyect';

function Pokedex() {
    const infoTect = ["React", "HTML", "CSS", "JavaScript", "Gsap", "", "", "", "", ""];
    const infoProyect = [
        "Pokedex",
        "https://www.youtube.com/embed/80leRo4rITc",
        "Interact with the pokedex and see the pokemon you can find!",
        "https://brandongrimaldom.github.io/pokedex/",
        "/web-development"
    ];

    return (
        <React.Fragment>
            <TemplateProyect
                title={infoProyect[0]}
                video={infoProyect[1]}
                description={infoProyect[2]}
                github={infoProyect[3]}
                tecfilter={infoTect}
                after={infoProyect[4]}  >
            </TemplateProyect>
        </React.Fragment>
    );
}
export default Pokedex;